import React, { useEffect, useRef, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Container,
  Stack,
  Typography,
  TextField,
  InputAdornment,
  IconButton
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../Store/mainSlice';
import httpClient from '../../_util/api';
import { UploadImagetoFb } from '../../Hooks/uploadImage';
import CustomizedSnackbars from '../../shared/Snackbar/SnackBar';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const EditProfile = () => {
  const userdetail = useSelector((state) => state.mainSlice.userdetail);
  const { role } = userdetail;
  const snackbar_Ref = useRef();
  const profilePhotoRef = useRef();
  const dispatch = useDispatch();

  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNo_Mobile: '',
    profilePic: {
      fileName: '',
      url: ''
    },
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (value, field) => {
    setUserData((prevData) => ({ ...prevData, [field]: value }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const uploadPhotoHandler = () => {
    profilePhotoRef.current.click();
  };

  console.log("userData",userData);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    dispatch(showLoader());

    try {
      const uploadedImage = await UploadImagetoFb(event);

      if (uploadedImage?.url) {
        const newFile = {
          fileName: file.name,
          url: uploadedImage.url
        };

        setUserData((prevFormData) => ({
          ...prevFormData,
          profilePic: newFile
        }));
      } else {
        throw new Error('Upload returned no URL');
      }
    } catch (err) {
      console.error('Upload error:', err);
      alert('File upload failed. Please try again.');
    } finally {
      dispatch(hideLoader());
    }
  };

  const getDetailsById = async () => {
    dispatch(showLoader());
    try {
      const res = await httpClient.get('/user/getUserDetailsById');
      if (res?.status === 200) {
        setUserData(res.data.user);
      }
    } catch (error) {
      snackbar_Ref.current.showMessage(
        'error',
        error?.response?.data?.message,
        '',
        'i-chk-circle'
      );
    } finally {
      dispatch(hideLoader());
    }
  };

  const updateProfileHandler = async () => {
    dispatch(showLoader());
    try {
      const res = await httpClient.post('/user/updateprofile', userData);
      if (res?.status === 200) {
        snackbar_Ref.current.showMessage(
          'success',
          res?.data?.message,
          '',
          'i-chk-circle'
        );
      }
    } catch (error) {
      snackbar_Ref.current.showMessage(
        'error',
        error?.response?.data?.message,
        '',
        'i-chk-circle'
      );
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    getDetailsById();
  }, []);

  return (
    <Container maxWidth="md">
      <Typography variant="h6" sx={{ mb: 4 }} fontWeight="bold">
        Profile Edit
      </Typography>

      <CustomizedSnackbars ref={snackbar_Ref} />

      <Box
        sx={{
          display: 'flex',
          p: 4,
          borderRadius: '12px',
          boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Avatar
            src={userData.profilePic?.url}
            sx={{ width: 100, height: 100, mx: 'auto', mb: 2 }}
          />
          <Button
            variant="contained"
            onClick={uploadPhotoHandler}
            sx={{ mt: 2, bgcolor: '#2f62a5', ':hover': { bgcolor: '#24528c' } }}
          >
            Upload Photo
          </Button>
          <input
            ref={profilePhotoRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
        </Box>
        <Box sx={{ flex: 2, pl: 4 }}>
          <Stack spacing={2}>
            <TextField
              label="First Name"
              value={userData.firstName}
              onChange={(e) => handleInputChange(e.target.value, 'firstName')}
              fullWidth
            />
            {role == "student" && (
              <TextField
                label="Last Name"
                value={userData.lastName}
                onChange={(e) => handleInputChange(e.target.value, 'lastName')}
                fullWidth
              />
            )}
            <TextField
              label="Email"
              value={userData.email}
              onChange={(e) => handleInputChange(e.target.value, 'email')}
              fullWidth
            />
            {role == "student" && (
              <TextField
                label="Phone Number"
                value={userData.phoneNo_Mobile}
                onChange={(e) => handleInputChange(e.target.value, 'phoneNo_Mobile')}
                fullWidth
              />
            )}
            <TextField
              label="Enter Password"
              type={showPassword ? 'text' : 'password'}
              value={userData.password}
              onChange={(e) => handleInputChange(e.target.value, 'password')}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <Button
              onClick={updateProfileHandler}
              variant="contained"
              sx={{ bgcolor: 'green', ':hover': { bgcolor: 'darkgreen' } }}
            >
              Update Profile
            </Button>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
};

export default EditProfile;
